import { StateCreator } from "zustand";
import { AgentsActions, AgentsStore } from "./agentsTypes";
import { initialAgentsState } from "./agentsState";
import { DEFAULT_PAGE_INDEX } from "../agents.constants";
import { AgentsFilters } from "../agents.model";

export const createAgentsActions: StateCreator<AgentsStore, [], [], AgentsActions> = (set) => ({
    setPageIndex: (pageIndex: number) => set({ pageIndex }),

    setPageSize: (pageSize: number) => {
        set({ pageSize, pageIndex: DEFAULT_PAGE_INDEX });
    },

    setSearchParam: (searchParam: string | null) => {
        set({ searchParam, pageIndex: DEFAULT_PAGE_INDEX });
    },

    setFilters: (filters: AgentsFilters) => {
        set({ filters, pageIndex: DEFAULT_PAGE_INDEX });
    },

    setSortRequest: (sortRequest) => set({ sortRequest }),

    clearAgentsError: () => set({ agentsError: null }),

    resetAgentsState: () => set(initialAgentsState),
});
